<script setup>
const API_BASE = import.meta.env.VITE_API_URL || 'https://api.krate.sh'
const loginGitHubUrl = `${API_BASE}/api/auth/github`
const loginGoogleUrl = `${API_BASE}/api/auth/google`
</script>

<template>
  <div class="login-page">
    <div class="login-card">
      <router-link to="/" class="brand">
        <img src="/img/logo.svg" alt="" width="40" height="40" />
        <span>krate</span>
      </router-link>

      <h1 class="heading">Sign in to krate</h1>
      <p class="sub">Choose a provider to continue.</p>

      <div class="idp-stack">
        <a :href="loginGitHubUrl" data-umami-event="signin-github" data-umami-event-location="signin-page" class="idp-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.4 3-.405 1.02.005 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
          </svg>
          <span>Sign in with GitHub</span>
        </a>

        <a :href="loginGoogleUrl" data-umami-event="signin-google" data-umami-event-location="signin-page" class="idp-btn">
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <span>Sign in with Google</span>
        </a>
      </div>

      <p class="waitlist-note">
        Not approved yet?
        <router-link to="/#waitlist" data-umami-event="cta-signin-waitlist" class="waitlist-link">Join the beta waitlist</router-link>
      </p>
    </div>
  </div>
</template>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-krate-dark-50, #f8fafc);
  padding: 2rem 1rem;
}
.login-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
}
.brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-krate-blue-600);
  margin-bottom: 1.5rem;
}
.heading {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.35rem 0;
  text-align: center;
}
.sub {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0 0 1.75rem 0;
  text-align: center;
}
.idp-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 1.5rem;
}
.idp-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  background: #fff;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  text-decoration: none;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
  width: 100%;
}
.idp-btn:hover {
  background: var(--color-krate-blue-600);
  color: #fff;
  border-color: var(--color-krate-blue-600);
}
.idp-btn svg { flex-shrink: 0; }
.idp-btn span { flex: 1; text-align: center; }
.waitlist-note {
  font-size: 0.8rem;
  color: #94a3b8;
  text-align: center;
  margin: 0;
}
.waitlist-link {
  color: var(--color-krate-blue-600);
  text-decoration: none;
  font-weight: 500;
}
.waitlist-link:hover { text-decoration: underline; }
</style>
